import { createFileRoute } from '@tanstack/react-router';
import { TranscriptionMonitor } from '@/pages/super-admin/transcription-monitor';

export const Route = createFileRoute('/_authenticated/super-admin/transcription-monitor')({
	component: TranscriptionMonitor,
});
